
import { RiHistoryFill } from "react-icons/ri"
import { TbFileDownload } from "react-icons/tb"
import { AiOutlineFileAdd } from "react-icons/ai"
import { NavLink } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi"
import BackComponent from "../components/BackArrow";
import Speedometer from "../screens/DataEntryOperator/Dashboard/RiskProfile/Speedometer";
import React, { useEffect, useState } from "react";
import WebService, { BASE_URL } from "../utility/WebService";
import HelperService from "../utility/HelperService";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader/Loader";



const UpdateRiskProfile = () => {

  const [showLoader, setShowLoader] = useState(false);
  const [riskProfile, setRiskProfile] = useState<any>([])
  let history = useNavigate();


  useEffect(() => {
    getDetail();
  }, [])

  const getDetail = () => {
    setShowLoader(true);
    WebService.getAPI({
      action: `/v2/NewRiskProfileAnswerDetails/Getdetail`,
      body: null
    })
      .then((res: any) => {
        setRiskProfile(res.result)
        setShowLoader(false);

      })
      .catch((e) => {
        setShowLoader(false);
      })
  }



  const getColor = (final_result: any) => {
    if (final_result == "Conservative") {
      return 'Conservative-color';
    }

    if (final_result == "Moderate") {
      return 'Moderate-color';
    }

    if (final_result == "Moderately aggressive") {
      return 'Moderately-color';
    }

    if (final_result == "Aggressive") {
      return 'Aggressive-color';
    }

    if (final_result == "Moderately conservative") {
      return 'Moderately-conservative-color';
    }

  }

  const downloadRiskProfile = () => {
    setShowLoader(false);
    window.open(`${BASE_URL}/v2/NewRiskProfileAnswerDetails/DownloadActiveRiskProfile?id=${riskProfile.risk_profile_answer_id}&customer_basics_id=${riskProfile.customer_basics_id}`)
  }


  return (
    <>
    <Loader show ={showLoader}/>
      <div className="page-content-wraper">
        <div className="grid grid-cols-2 gap-4 mb-3">
          <div> <BackComponent title={'Update Risk Profile'} /></div>
        </div>

        <div className="rounded-xl bg-white p-4 mb-4">
          <div className="grid grid-cols-3 gap-4   items-center">
            <div className="text-center">
              <Speedometer meter={riskProfile.system_risk_profile} />
              <div className= {getColor(riskProfile.system_risk_profile)} style={{fontSize:21, fontWeight: "bold" }}> {riskProfile.system_risk_profile}</div>
            </div>
            <div className="text-center">
              <p>Submitted on {riskProfile.created_at ? HelperService.getFormatedDateAndTime(riskProfile.created_at) : "-"}</p>
              {/* <p>Expires on 15-Nov-2023</p> */}
            </div>
            <div className="  text-right">
              <button type="button" className="btn btn-white mb-3 block ml-auto border border-black w-52"  onClick={() => history(`/dashboard/risk-profile-history`)}><span className="text-black"><RiHistoryFill size={18} className="mr-1" /> History</span> </button>
              <button type="button" className="btn btn-brand-outline mb-3 block ml-auto w-52 h-10" onClick={() => { downloadRiskProfile() }} ><TbFileDownload size={18} className="mr-1" />Download Risk Profile</button>
              <NavLink to="/dashboard/new-risk-profile" className="btn btn-brand block ml-auto w-52 h-10 px-3"><AiOutlineFileAdd size={18} className="mr-1" /><span className=" "> New Risk Profile </span><HiArrowNarrowRight size={18} /></NavLink>
            </div>
          </div>
        </div>



      </div>
    </>
  )
}
export default UpdateRiskProfile;